import logo from "./assets/img/beauty-tech-logo.png";
import logoAriane from "./assets/img/laser-ariane.png";
import logoEpilab from "./assets/img/epilab.png";
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  return (
    <div className="home">
      {/* Section héro avec fond */}
      <section className="hero-section">
        <div className="hero-background"></div>

        <div className="hero-content">
          <img className="hero-content-logo" src={logo} alt="Beauty-Tech" />
          <p>Choisissez votre équipement et configurez-le selon vos besoins</p>

          <div className="configurator-cards">
            <Link to="/configurateur-ariane" className="configurator-card ariane">
              <img className="configurator-card-logo" src={logoAriane} alt="Laser Ariane" width={200}/>
              <p>Première plateforme française combinant les technologies LASER et lumière pulsée.</p>
              <span className="card-arrow">Configurer →</span>
            </Link>

            {/* <Link to="/configurateur-epilab" className="configurator-card epilab"> */}
            <div className="configurator-card epilab">
              <img className="configurator-card-logo" src={logoEpilab} alt="Epilab" width={200}/>
              <p>EPILAB utilise la technologie la plus avancée du marché de l’épilation.</p>
              <span className="card-arrow">En cours de développement...</span>
            </div>
            {/* </Link> */}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
